import GLOBAL from '@/api/global_variable'
var echarts = null
export default {
  echarts,
  setEcharts: function (ec) {
    this.echarts = ec
  },
  getOption1: function (scaleData) {
    var rich = {
      white: {
        color: '#ddd',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#1C97DB', '#ff3000', '#EE9717', '#9E42E6', '#ff6c80', '#037ef0', '#ff8ce0']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 0, // 2
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [90, 95],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return params.name + '\n{white|' + '占比' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 20,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      tooltip: {
        show: false
      },
      legend: {
        show: false
      },
      toolbox: {
        show: false
      },
      title: {
        text: '未按期维保',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption2: function (scaleData) {
    var rich = {
      white: {
        color: '#ddd',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    // ff3000
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#1C97DB', '#ff3000', '#EE9717', '#9E42E6', '#ff6c80', '#037ef0', '#ff8ce0']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 0, // 2
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [90, 95],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return params.name + '\n{white|' + '占比' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 20,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      tooltip: {
        show: false
      },
      legend: {
        show: false
      },
      toolbox: {
        show: false
      },
      title: {
        text: '未按期年检',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption3: function (x, s1, s2) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#5295CB', '#FF6666', '#FFCA6C'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['维保', '年检'],
        show: true,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize:12
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            textStyle: {
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          }
        }
      ],
      series: [
        {
          name: '维保',
          type: 'line',
          smooth: true,
          itemStyle: {
            color: 'rgb(255, 70, 131)',
            normal: {
              areaStyle: {
                color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(94, 228, 225)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 2,
                type: 'solid',
                color: 'rgb(94, 228, 225' // 折线的颜色
              }
            }
          },
          data: s1,
          symbol: 'none',
          sampling: 'average'
        },
        {
          name: '年检',
          type: 'line',
          smooth: true,
          itemStyle: {
            color: 'rgb(255, 70, 131)',
            normal: {
              areaStyle: {
                color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(94, 228, 225)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 2,
                type: 'solid',
                color: 'rgb(94, 228, 225)' // 折线的颜色
              }
            }
          },
          data: s2,
          symbol: 'none',
          sampling: 'average'
        }
      ]
    }
    return option
  },
  getOption4: function (data, total) {
    let color = ['#D14646', '#FFCA6C', '#1DB7E5']
    let data1 = data[0].value + data[1].value
    let baseData = []
    for (var i = 0; i < data.length; i++) {
      baseData.push({
        value: data[i].value,
        name: data[i].name,
        itemStyle: {
          normal: {
            borderWidth: 22,
            shadowBlur: 50,
            borderColor: color[i],
            shadowColor: 'rgba(0, 0, 0, 0.8)'
          }
        }
      })
    }
    var option = {
      backgroundColor: '#2c343c',
      color: color,
      tooltip: {
        show: true,
        trigger: 'item',
        formatter: '{a}：{b} <br/>占比：{d}%'
      },
      legend: {
        data: ['人工报警', '故障报警'],
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      grid: {
        top: 'bottom',
        left: '90',
        width: '90%',
        height: '80%'

      },
      series: [{
        zlevel: 1,
        name: '数据采集',
        type: 'pie',
        selectedMode: 'single',
        radius: [95, 98],
        startAngle: '135',
        hoverAnimation: false,
        label: {
          normal: {
            show: true,
            formatter: ['{b|{b}}', '{c|{c}}'].join('\n'),
            rich: {
              b: {
                fontSize: 12,
                lineHeight: 16
              }

            },
            labelLine: {
              length: 2,
              length2: 2,
              show: true,
              color: '#00ffff'
            }
          }
        },
        itemStyle: {
          normal: {
            shadowColor: 'rgba(0, 0, 0, 0.8)',
            shadowBlur: 40,
            labelLine: {
              length: 20,
              length2: 5,
              show: true,
              color: '#00ffff'
            }
          }
        },
        data: baseData
      },
      {
        name: '',
        type: 'pie',
        selectedMode: 'single',
        radius: [95, 100],
        startAngle: '195',
        data: [{
          'value': data1,
          'name': '',
          'label': {
            'normal': {
              'show': true,
              'formatter': '{c|{c}} {b|条} \n {a|累计事件}',
              rich: {
                c: {
                  color: '#FBFE27',
                  fontSize: 20,
                  fontWeight: 'bold',
                  lineHeight: 10
                },
                b: {
                  color: '#FBFE27',
                  fontSize: 20,
                  lineHeight: 10
                },
                a: {
                  align: 'center',
                  color: 'rgb(98,137,169)',
                  fontSize: 12,
                  height: 20
                }
              },
              'textStyle': {
                'fontSize': 16,
                'fontWeight': 'bold'
              },
              'position': 'center'

            }
          }
        }]
      }
      ]
    }
    return option
  },
  getOption5: function (x, s1, s2) {
    var option = {
      color: ['#D14646', '#FFCA6C', '#1DB7E5'],
      grid: {
        left: '2%',
        right: '2%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['人工报警', '故障报警'],
        show: true,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
            // ,
            // formatter: function (val) {
            //   console.log(val)
            //   if (val === '10月' || val === '11月' || val === '12月') {
            //     return val.substr(0, 2) + '\n月'
            //   } else {
            //     return val.split('').join('\n')
            //   }
            // }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: false, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '人工报警',
          type: 'bar',
          data: s1
        },
        {
          name: '故障报警',
          type: 'bar',
          data: s2
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  getOption6: function (x, s1, s2) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#D14646', '#ffba55', '#4691CE'],
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['人工报警', '故障报警'],
        show: true,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '人工报警',
          type: 'bar',
          data: s1
        },
        {
          name: '故障报警',
          type: 'bar',
          data: s2
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  getOption7: function (x, s1, s2) {
    var option = {
      color: ['#4691CE', '#ffba55', '#D14646'],
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['电梯总数', '终端数'],
        show: true,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            },
            formatter: function (val) {
              return val.split('').join('\n')
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: false, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '电梯总数',
          type: 'bar',
          data: s1
        },
        {
          name: '终端数',
          type: 'bar',
          data: s2
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  getOption8: function (v1, v2, v3) {
    var option = {
      title: [
        {
          text: '累计人工报警事件处理完成情况',
          left: '23%',
          top: '1%',
          textAlign: 'center',
          textStyle: {
            fontWeight: 'normal',
            fontSize: '14',
            color: '#fff',
            textAlign: 'center'
          }
        }, {
          text: '累计故障报警事件处理完成情况',
          left: '73%',
          top: '1%',
          textAlign: 'center',
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: '14',
            textAlign: 'center'
          }
        }, {
          text: '累计投诉事件处理完成情况',
          left: '23%',
          top: '52%',
          textAlign: 'center',
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: '14',
            textAlign: 'center'
          }
        }],
      series: [
        {
          name: ' 累计人工报警',
          type: 'pie',
          radius: ['35%', '40%'],
          center: ['25%', '30%'],
          startAngle: 0,
          color: ['#D14646', '#2b2a3d'],
          labelLine: {
            normal: {
              show: false
            }
          },
          label: {
            normal: {
              position: 'center'
            }
          },
          data: [{
            // value: v1[0],
            value: v1[1] === 0 ? 100 : (v1[1] / v1[0] * 100),
            name: '累计人工报警',
            label: {
              show: false,
              normal: {
                show: false,
                formatter: '累计人工报警',
                textStyle: {
                  color: '#fff',
                  fontSize: 14

                }
              }
            }
          }, {
            // value: v1[1],
            value: 100 - (v1[1] / v1[0] * 100),
            name: '%',
            label: {
              normal: {
                formatter: '\n' + v1[0],
                textStyle: {
                  color: '#D14646',
                  fontSize: 22,
                  fontWeight: 'bold'
                }
              }
            }
          }, {
            value: 0,
            name: '%',
            label: {
              normal: {
                // formatter: (v1[1] / v1[0] * 100).toFixed(2) + '%',
                formatter: (v1[1] === 0 ? 100 : (v1[1] / v1[0] * 100)).toFixed(2) + '%',
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                }
              }
            }
          }]
        },
        {
          name: ' 累计故障报警',
          type: 'pie',
          radius: ['35%', '40%'],
          center: ['75%', '30%'],
          startAngle: 0,
          color: ['#FFCA6C', '#2b2a3d'],
          labelLine: {
            normal: {
              show: false
            }
          },
          label: {
            normal: {
              position: 'center'
            }
          },
          data: [{
            // value: v2[0],
            value: v2[1] === 0 ? 100 : (v2[1] / v2[0] * 100),
            name: '累计故障报警',
            label: {
              normal: {
                show: false,
                formatter: '累计故障报警',
                textStyle: {
                  color: '#fff',
                  fontSize: 14
                }
              }
            }
          }, {
            // value: v2[1],
            value: 100 - (v2[1] / v2[0] * 100),
            name: '%',
            label: {
              normal: {
                formatter: '\n' + v2[0],
                textStyle: {
                  color: '#FFCA6C',
                  fontSize: 22,
                  fontWeight: 'bold'
                }
              }
            }
          }, {
            value: 0,
            name: '%',
            label: {
              normal: {
                // formatter: (v2[1] / v2[0] * 100).toFixed(2) + '%',
                formatter: (v2[1] === 0 ? 100 : (v2[1] / v2[0] * 100)).toFixed(2) + '%',
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                }
              }
            }
          }]
        },
        {
          name: ' 累计投诉',
          type: 'pie',
          radius: ['35%', '40%'],
          center: ['25%', '80%'],
          startAngle: 0,
          color: ['#4691CE', '#4691CE'],
          labelLine: {
            normal: {
              show: false
            }
          },
          label: {
            normal: {
              position: 'center'
            }
          },
          data: [{
            // value: v3[0],
            value: v3[1] === 0 ? 100 : (v3[1] / v3[0] * 100),
            name: '累计投诉',
            label: {
              normal: {
                show: false,
                formatter: '累计投诉',
                textStyle: {
                  color: '#fff',
                  fontSize: 14

                }
              }
            }
          }, {
            // value: 100 - (v3[1] / v3[0] * 100),
            value: v3[1],
            name: '%',
            label: {
              normal: {
                formatter: '\n' + v3[0],
                textStyle: {
                  color: '#4691CE',
                  fontSize: 22,
                  fontWeight: 'bold'
                }
              }
            }
          }, {
            value: 0,
            name: '%',
            label: {
              normal: {
                formatter: (v3[1] === 0 ? 100 : (v3[1] / v3[0] * 100)).toFixed(2) + '%',
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                }
              }
            }
          }]
        }
      ]
    }
    return option
  },
  chartsProOption: function (e, c, d) {
    var option = {
      color: [c, '#202956'],
      title: {
        show: true,
        text: e + '%',
        subtext: '完成' + d + '起',
        x: 'center',
        y: '30px',
        itemGap: 5,
        textStyle: {
          fontSize: 18,
          color: c,
          fontWeight: '500'
        },
        subtextStyle: {
          color: '#fff',
          fontFamily: '微软雅黑',
          fontSize: 10,
          fontWeight: 'normal'
        }
      },
      legend: {
        orient: 'vertical',
        x: 'left',
        show: false
      },
      series: {
        name: '',
        type: 'pie',
        radius: ['73%', '85%'],
        label: {
          normal: {
            show: false,
            position: 'center'
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: [
          { value: e, name: '' },
          { value: 100 - e, name: '' }
        ]
      }
    }
    return option
  },
  charts1Option: function (s1, s2) {
    var option = {
      backgroundColor: '#0b133f',
      title: {
        text: '全年年检维保异常状态统计图',
        textStyle: {
          color: '#FFF',
          fontFamily: '微软雅黑',
          fontSize: 16,
          fontWeight: 'bolder'
        }
      },
      color: ['#FF6666', '#FFCA6C', '#5295CB'],
      tooltip: {
        trigger: 'axis'
      },

      grid: {
        left: '1%',
        right: '3%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            textStyle: {
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          }
        }
      ],
      series: [
        {
          name: '维保',
          type: 'line',
          smooth: true,
          itemStyle: {
            color: 'rgb(255, 70, 131)',
            normal: {
              areaStyle: {
                color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(94, 228, 225)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 2,
                type: 'solid',
                color: 'rgb(94, 228, 225' // 折线的颜色
              }
            }
          },
          data: s1,
          symbol: 'none',
          sampling: 'average'
        },
        {
          name: '年检',
          type: 'line',
          smooth: true,
          itemStyle: {
            color: 'rgb(255, 70, 131)',
            normal: {
              areaStyle: {
                color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(94, 228, 225)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 2,
                type: 'solid',
                color: 'rgb(94, 228, 225' // 折线的颜色
              }
            }
          },
          data: s2,
          symbol: 'none',
          sampling: 'average'
        }
      ]
    }
    return option
  },
  charts2Option: function (vv1, vv2, vv3, data) {
    var dataStyle = {
      normal: {
        label: { show: false },
        labelLine: { show: false }
      }
    }
    var placeHolderStyle = {
      normal: {
        color: 'rgba(0,0,0,0)',
        label: { show: false },
        labelLine: { show: false }
      },
      emphasis: {
        color: 'rgba(0,0,0,0)'
      }
    }
    var option = {
      backgroundColor: '#0b133f',
      color: ['#FF6666', '#FFCA6C', '#5295CB'],
      title: {
        text: '梯云IOT',
        sublink: 'http://e.weibo.com/1341556070/AhQXtjbqh',
        x: 'center',
        y: 'center',
        itemGap: 30,
        textStyle: {
          color: '#5295CB',
          fontFamily: '微软雅黑',
          fontSize: 16,
          fontWeight: 'bolder'
        }
      },
      tooltip: {
        show: true,
        formatter: '{b}'
      },
      legend: {
        orient: 'vertical',
        x: (document.getElementById('charts2').offsetWidth / 2) + 10,
        y: 6,
        itemGap: 16,
        textStyle: {
          color: '#fff',
          fontFamily: '微软雅黑',
          fontWeight: 'bolder'
        },
        data: [
          ('累计提醒事件完成' + data.StatusQuantity.AlarmQuantity + '起'),
          ('累计投诉事件完成' + data.StatusQuantity.FaultQuantity + '起'),
          ('累计报警事件完成' + data.StatusQuantity.ComplaintQuantity + '起')
        ]
      },
      toolbox: {
        show: false
      },
      series: [
        {
          name: '1',
          type: 'pie',
          clockWise: false,
          radius: [92, 106],
          itemStyle: dataStyle,
          data: [
            {
              value: vv1[0],
              name: ('累计提醒事件完成' + data.StatusQuantity.AlarmQuantity + '起')
            },
            {
              value: vv1[1],
              name: 'invisible',
              itemStyle: placeHolderStyle
            }
          ]
        },
        {
          name: '2',
          type: 'pie',
          clockWise: false,
          radius: [62, 76],
          itemStyle: dataStyle,
          data: [
            {
              value: vv2[0],
              name: ('累计投诉事件完成' + data.StatusQuantity.FaultQuantity + '起')
            },
            {
              value: vv2[1],
              name: 'invisible',
              itemStyle: placeHolderStyle
            }
          ]
        },
        {
          name: '3',
          type: 'pie',
          clockWise: false,
          radius: [32, 46],
          itemStyle: dataStyle,
          data: [
            {
              value: vv3[0],
              name: ('累计报警事件完成' + data.StatusQuantity.ComplaintQuantity + '起')
            },
            {
              value: vv3[1],
              name: 'invisible',
              itemStyle: placeHolderStyle
            }
          ]
        }
      ]
    }
    return option
  },
  charts3Option: function (x, s1, s2) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#5295CB', '#FFCA6C', '#FFCA6C'],
      title: {
        text: '郴州市各区县电梯分布情况统计',
        textStyle: {
          color: '#fff',
          fontFamily: '微软雅黑',
          fontSize: 16,
          fontWeight: 'bolder'
        }
      },
      grid: {
        left: '1%',
        right: '0%',
        bottom: '0%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['蒸发量', '降水量'],
        show: false
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            },
            formatter: function (val) {
              return val.split('').join('\n')
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '电梯总数',
          type: 'bar',
          data: [3482, 1481, 596, 305, 425, 306, 181, 290, 71, 293, 349]
        },
        {
          name: '终端数',
          type: 'bar',
          data: s1
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  charts5Option: function (x, s1, s2, s3) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#AC2A35', '#9A4F3B', '#FFCA6C'],
      tooltip: {
        trigger: 'axis'
      },

      grid: {
        left: '4%',
        right: '4%',
        bottom: '8%',
        top: '16%',
        containLabel: true
      },
      legend: {
        show: true,
        data: ['故障次数', '处理次数', '投诉次数'],
        icon: 'roundRect', //  字段控制形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
        itemWidth: 30, // 设置宽度
        itemHeight: 14, // 设置高度
        itemGap: 40, // 设置间距
        textStyle: {
          'color': '#fff'
        },
        x: 30,
        y: 0
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            textStyle: {
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      series: [
        {
          name: '故障次数',
          type: 'bar',
          smooth: true,
          data: s1,
          symbol: 'none',
          sampling: 'average'
        },
        {
          name: '处理次数',
          type: 'bar',
          smooth: true,
          data: s2,
          symbol: 'none',
          sampling: 'average'
        },
        {
          name: '投诉次数',
          type: 'line',
          smooth: true,
          data: s3,
          symbol: 'none',
          sampling: 'average',
          itemStyle: {
            normal: {
              areaStyle: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(245, 162, 0)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 0,
                type: 'solid',
                color: 'rgb(209, 99, 99)' // 折线的颜色
              }
            }
          }
        }
      ]
    }
    return option
  },
  charts6Option: function (x, s1, s2, s3) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#5295CB', '#FFCA6C', '#FFCA6C'],
      title: {
        text: '郴州市全年应急处置情况',
        textStyle: {
          color: '#fff',
          fontFamily: '微软雅黑',
          fontSize: 16,
          fontWeight: 'bolder'
        }
      },
      grid: {
        left: '1%',
        right: '0%',
        bottom: '0%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['人工报警', '异常提醒', '投诉建议'],
        show: false
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '人工报警',
          type: 'bar',
          data: s1
        },
        {
          name: '异常提醒',
          type: 'bar',
          data: s2
        },
        {
          name: '投诉建议',
          type: 'bar',
          data: s3
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  charts8Option: function (totalNum, s) {
    var option = {
      backgroundColor: '#0b133f',
      color: ['#5295CB', '#FF6666', '#FFCA6C', '#39FF80'],
      title: {
        text: '电梯总数',
        subtext: totalNum,
        x: 'center',
        y: 'center',
        itemGap: 10,
        textStyle: {
          color: '#fff',
          fontFamily: '微软雅黑',
          fontSize: 13
        },
        subtextStyle: {
          color: '#5295CB',
          fontFamily: '微软雅黑',
          fontSize: 25,
          fontWeight: 'bolder'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        show: false
      },
      calculable: true,
      series: [
        {
          name: '电梯数量',
          type: 'pie',
          radius: ['50%', '70%'],
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            },
            emphasis: {
              label: {
                show: false
              }
            }
          },
          data: s
        }
      ]
    }
    return option
  },
  charts7Option: function (s) {
    var option = {
      color: ['#5295CB', '#FF6666', '#FFCA6C', '#39FF80'],
      title: {
        text: '全年应急处置异常统计',
        textStyle: {
          color: '#FFF',
          fontFamily: '微软雅黑',
          fontSize: 16,
          fontWeight: 'bolder'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      calculable: true,
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: [40, 60],
          center: ['50%', '60%'],
          // for funnel
          x: '50%',
          width: '35%',
          funnelAlign: 'left',
          max: 1048,
          labelLine: {
            normal: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              }
            }
          },
          data: s
        }
      ]
    }
    return option
  },
  randomNum: function (minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1, 10)
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      default:
        return 0
    }
  },
  chartsMap: function (data) {
    console.log('chartsMap')
    console.log(data)
    // 首页地图圆圈显示位置
    var geoCoordMap = []
    geoCoordMap['颍州区'] = [115.813914, 32.891238]
    geoCoordMap['颍东区'] = [115.858747, 32.908861]
    geoCoordMap['颍泉区'] = [115.804525, 32.924797]
    geoCoordMap['临泉县'] = [115.261688, 33.062698]
    geoCoordMap['太和县'] = [115.627243, 33.16229]
    geoCoordMap['阜南县'] = [115.590534, 32.638102]
    geoCoordMap['颍上县'] = [116.259122, 32.637065]
    geoCoordMap['界首市'] = [115.362117, 33.26153]
    var mapData = []
    for (var key in geoCoordMap) {
      mapData.push({ 'name': key, 'value': this.randomNum(100, 300) })
    }
    var convertData = function (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    }
    var option = {
      backgroundColor: '#0b133F',
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          if (typeof (params.value)[2] === 'undefined') {
            return params.name + ' : ' + params.value
          } else {
            return params.name + ' : ' + params.value[2]
          }
        }
      },
      toolbox: {
        show: false
      },
      geo: {
        show: true,
        map: '阜阳市',
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          emphasis: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        roam: true,

        itemStyle: {
          normal: {
            borderColor: 'rgba(147, 235, 248, 1)',
            borderWidth: 1,
            areaColor: {
              type: 'radial',
              x: 0.5,
              y: 0.5,
              r: 0.8,
              colorStops: [{
                offset: 0,
                color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
              }, {
                offset: 1,
                color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
              }],
              globalCoord: false // 缺省为 false
            },
            shadowColor: 'rgba(128, 217, 248, 1)',
            // shadowColor: 'rgba(255, 255, 255, 1)',
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10
          },
          emphasis: {
            areaColor: '#389BB7',
            borderWidth: 0
          }
        }
      },
      series: [{
        data: convertData(data),
        type: 'effectScatter',
        coordinateSystem: 'geo',
        // symbol: 'diamond',
        showEffectOn: 'render',
        rippleEffect: {
          period: 12,
          scale: 3,
          brushType: 'fill'
        },
        hoverAnimation: true,
        itemStyle: {
          normal: {
            color: 'rgba(147, 235, 248, 1)',
            shadowBlur: 10,
            shadowColor: '#333'
          }
        }
      }, {
        type: 'map',
        map: '阜阳市',
        geoIndex: 0,
        aspectScale: 0.75, // 长宽比
        showLegendSymbol: false, // 存在legend时显示
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false,
            textStyle: {
              color: '#fff'
            }
          }
        },
        roam: true,
        itemStyle: {
          normal: {
            areaColor: '#031525',
            borderColor: '#3B5077'
          },
          emphasis: {
            areaColor: '#2B91B7'
          }
        },
        animation: false,
        data: data
      },
      {
        name: 'Top 5',
        type: 'effectScatter',
        coordinateSystem: 'geo',
        data: data,
        symbolSize: 10,
        showEffectOn: 'render',
        rippleEffect: {
          brushType: 'stroke'
        },
        hoverAnimation: true,
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: true
          }
        },
        itemStyle: {
          normal: {
            color: '#05C3F9',
            shadowBlur: 10,
            shadowColor: '#05C3F9'
          }
        },
        zlevel: 1
      }

      ]
    }
    return option
  }
}



// WEBPACK FOOTER //
// ./src/api/charts_view1.js